<template>
<app-modal :shown="shown" @close="handleClose" class="modal-login">
    <div class="center-content-position">
      <div>
        <h1>Account details</h1>
        <div class="user-details">
          <div class="user-details-item">
            <div class="item-left">
              <span>User Name</span>
            </div>
            <div class="item-right">
              <span>{{ user.name }}</span>
              <span v-if="internal"> (internal)</span>
            </div>
          </div>
        </div>
        <div class="user-details">
          <div class="user-details-item">
            <div class="item-left">
              <span>User ID</span>
            </div>
            <div class="item-right">
              <span>{{ user.userId }}</span>
            </div>
          </div>
        </div>
        <div class="user-details">
          <div class="user-details-item">
            <div class="item-left">
              <span>Subscription</span>
            </div>
            <div class="item-right">
              <span>{{ subscriptionText }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center-content-position">
      <div class="modal-footer">
        <span class="app-version-number">V {{ version }}</span>
        <button @click="showIntercom" class="cta-button medium-button-dark">
          Discuss Subscription
        </button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { mapActions } from 'vuex'
import appModal from 'components/common/app-modal.vue'
import cookies from 'src/services/cookies.service.js'
import packageJson from '../../../../package.json'
import { contactSupport } from 'src/services/support.service'

export default {
  name: 'modal-subsriber-details',
  components: {
    appModal,
  },
  props: ['shown'],
  data() {
    return {
      internal: cookies.getCookie('internal'),
      version: packageJson.version,
    }
  },
  computed: {
    user() {
      return this.$store.state.user.currentUser
    },
    subscriptionText() {
      const lookup = {
        basic: 'Basic subscription',
        advanced: 'Advanced subscription',
      }
      const level = _.get(this.user, 'cohort')
      return lookup[level] || 'No subscription'
    },
  },
  methods: {
    ...mapActions({
      hideModal: 'hideModal',
    }),
    handleClose() {
      this.$emit('close')
    },
    showIntercom() {
      contactSupport("Hello,\nI'd like to discuss my subscription")
    },
  },
}
</script>

<style lang="scss" scoped>
.center-content-position {
  width: 80% !important;
}
.user-details {
  margin-top: 20px;
}
.user-details-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 20px;
  &:hover {
    background-color: #eee;
  }
  .item-left {
    font-weight: 500;
  }
}
.modal-footer {
  margin-top: 10px;
  padding-top: 20px;
  position: relative;
}
.app-version-number {
  top: 30px;
  left: 15px;
  color: #555875;
  font-size: 10px;
  position: absolute;
  font-weight: 500;
  bottom: 45px;
}
</style>
